import * as React from 'react';
import { WithRouterProps } from 'react-router';

export class SearchBox extends React.Component<WithRouterProps,{searchBoxText: string}> {
    constructor(props: WithRouterProps) {
        super(props);
        this.state = {
            searchBoxText: ""
        };
      }

    public render() {
        const redirectToSearch=() => {
            window.location.href = "https://www.google.com/search?q=site:" + window.location.origin + " " + this.state.searchBoxText;
        }
        const updateSearchBoxValue=(event: any) => {
            this.setState({
                'searchBoxText': event.target.value
            })
        }
        const updateSearchBoxOnKeyPress=(event: any) => {
            if (event.key === 'Enter') {
                redirectToSearch();
              }
        }

        return (
            <div className="search">
                <div className="search-field">
                    <input type="text" value={this.state.searchBoxText} onChange={updateSearchBoxValue} onKeyPress={updateSearchBoxOnKeyPress} />
                    <button className="search-button" onClick={redirectToSearch}><i className="fas fa-search"/></button>
                </div>
            </div>
        );
    };
};


// WEBPACK FOOTER //
// ./src/common/components/searchBox/searchBox.tsx